<template>
<div>
<TheSimonGame/>
</div>
</template>

<script>

import TheSimonGame from "../components/TheSimonGame.component";

export default {
  name: "TheSimonGame.container",

  components: {
    TheSimonGame
  }
}
</script>

<style scoped>

</style>



